var exports = {
  "kL": "xcc377c0b--3e007d--container",
  "wm": "xcc377c0b--3e007d--logo",
  "yr": "xcc377c0b--3e007d--logo-image",
  "ot": "xcc377c0b--3e007d--logo-icon",
  "pq": "xcc377c0b--3e007d--info",
  "nf": "xcc377c0b--3e007d--link",
};

module.exports = exports;
